import { IconButton } from '../../../../../../../common/components/iconButton/IconButton'
import { Input } from '../../../../../../../common/components/input/Input'
import { SearchSelect } from '../../../../../../../common/components/searchSelect/SearchSelect'
import classes from './Item.module.sass'
import trash from '../../../../../../../assets/images/icons/trash.svg'
import {
  OptionItemInterface,
  StockItemInterface,
  ValidationResultInterface,
} from '../../../../../../../common/types/interfaces'

type Props = {
  idx: number
  item: StockItemInterface
  onRemove: (index: number) => void
  onChange: (index: number, field: string, value: string | number) => void
  onBlur: (field: string) => void
  saleItemOptions: OptionItemInterface[]
  getItemValidationResult: (
    index: number,
    field: 'saleItemId' | 'count',
  ) => ValidationResultInterface | undefined
}

export const Item = ({
  idx,
  item,
  onRemove,
  onChange,
  onBlur,
  saleItemOptions,
  getItemValidationResult,
}: Props) => {
  return (
    <div className={classes.container}>
      <div className={classes.input}>
        <SearchSelect
          onBlur={() => onBlur(`movements[${idx}].saleItemId`)}
          fieldName={`movements[${idx}].saleItemId`}
          options={saleItemOptions}
          value={item.saleItemId}
          onChangeHandler={(value: string | number | boolean) => {
            if (typeof value === 'boolean') return
            onChange(idx, 'saleItemId', value)
          }}
          type="text"
          placeholder="Товар"
          itemValidationResult={getItemValidationResult(idx, 'saleItemId')}
        />
      </div>

      <div className={classes.countInput}>
        <Input
          type={'numberText'}
          fieldName={`movements[${idx}].count`}
          value={item.count ||''}
          placeHolder="Количество"
          onChangeHandler={(value: any) => onChange(idx, 'count', value)}
          onBlur={() => onBlur(`movements[${idx}].count`)}
          itemValidationResult={getItemValidationResult(idx, 'count')}
        />
      </div>

      <div className={classes.button}>
        <IconButton display onClick={() => onRemove(idx)} icon={trash} alt="Удалить" small />
      </div>
    </div>
  )
}
